export default __webpack_public_path__ + "static/media/team3.f4b84414.png";